
import { Typography, Button } from "../../components"
import "./styles.css";

import onderbouwingsubsidieverzoek from '../../assets/documents/library/onderbouwingsubsidieverzoek2026.pdf';

export default function OnderbouwingSubsidieverzoek(props) {
    return (
        <div className='container'>
            <Typography type='h1' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Onderbouwing subsidieverzoek</Typography>
            <div className="button-container">
                <Button 
                    target='_blank' 
                    href={onderbouwingsubsidieverzoek} 
                    text={`Klik hier voor onze ondersteunden subsidiedocumenten`}
                />  
            </div>
        </div>
    )
}
